import $ from 'jquery';
import { conditionalEnable } from '@/lib/checkboxes.js';
import Regions from '@/lib/regions.js';

export default function () {
	conditionalEnable('#vat', '#exempt-from-vat');

	new Regions($('.countries'));
}
